export default __webpack_public_path__ + "static/media/img6.13ab6193.png";